import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from "@angular/router";
import { MediaMatcher } from '@angular/cdk/layout';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.css']
})
export class TrendingComponent implements OnInit {
  hashtagsControlled: any;
  hashtags: any;
  isMobile = false;
  constructor(private zone: NgZone, private afs: AngularFirestore, private router: Router, private media: MediaMatcher) {



  }
  ngOnInit() {
  }
  navigate(to) {
    this.router.navigate(["/"]).then(() => {
      this.router.navigate([to]);
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/trending/trending.component.ts